var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4186 5.38967V5.08301C27.4186 2.32134 25.1803 0.0830078 22.4186 0.0830078C19.657 0.0830078 17.4186 2.32134 17.4186 5.08301H14.0853C14.0853 2.32134 11.847 0.0830078 9.08529 0.0830078C6.32362 0.0830078 4.08529 2.32134 4.08529 5.08301V5.38967C2.15029 6.08134 0.751953 7.91301 0.751953 10.083V25.083C0.751953 27.8397 2.99529 30.083 5.75195 30.083H25.752C28.5086 30.083 30.752 27.8397 30.752 25.083V10.083C30.752 7.91301 29.3536 6.08134 27.4186 5.38967ZM20.752 5.08301C20.752 4.16301 21.497 3.41634 22.4186 3.41634C23.3403 3.41634 24.0853 4.16301 24.0853 5.08301V8.41634C24.0853 9.33634 23.3403 10.083 22.4186 10.083C21.497 10.083 20.752 9.33634 20.752 8.41634V5.08301ZM7.41862 5.08301C7.41862 4.16301 8.16362 3.41634 9.08529 3.41634C10.007 3.41634 10.752 4.16301 10.752 5.08301V8.41634C10.752 9.33634 10.007 10.083 9.08529 10.083C8.16362 10.083 7.41862 9.33634 7.41862 8.41634V5.08301ZM27.4186 25.083C27.4186 26.0013 26.672 26.7497 25.752 26.7497H5.75195C4.83195 26.7497 4.08529 26.0013 4.08529 25.083V15.083H27.4186V25.083Z",
    fill: "#1F2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.a3f05e6c86be8597487cdfa43209743a.svg";
export { ForwardRef as ReactComponent };